export default "__VITE_ASSET__YsWWoDgz__"